import moment from 'moment';
import { lang } from 'common/lang';
import { OtpField } from './types';

const { documentRenewal } = lang;

const camelToSnakeCase = (propertyName: string) => propertyName
  .replace(
    /[A-Z]/g,
    (letter) => `_${letter.toLowerCase()}`,
  );

const snakeToCamelCase = (propertyName: string) => propertyName
  .toLowerCase()
  .replace(/([-_][a-z])/g, (group) => group
    .toUpperCase()
    .replace('-', '')
    .replace('_', ''));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseObjectPropertiesToSnakeCase = (object: any): any => {
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => {
      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        return [camelToSnakeCase(key), value];
      }
      const parsedNestedObject = parseObjectPropertiesToSnakeCase(value);
      return [camelToSnakeCase(key), parsedNestedObject];
    }),
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseObjectPropertiesToCamelCase = (object: any): any => {
  if (!object) {
    return;
  }
  return Object.fromEntries(
    Object.entries(object).map(([key, value]) => {
      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
        return [snakeToCamelCase(key), value];
      }
      const parsedNestedObject = parseObjectPropertiesToCamelCase(value);
      return [snakeToCamelCase(key), parsedNestedObject];
    }),
  );
};

export const camelCaseToTitleCase = (text: string): string => {
  return text.replace(/([A-Z])/g, ' $1').replace(/^./, (str: string) => str.toUpperCase());
};

export const combineOtp = (otpArray: OtpField): string => {
  const arr = Object.keys(otpArray).reduce((res, v) => {
    return res.concat(otpArray[v] as any);
  }, []);
  return arr.reverse().join('');
};

export const formateDate = (date: string): string => {
  if (!date) return '';
  // RenewalDate stores dates as DD/MM/YYYY but other callers pass ISO
  // timestamps from backend responses. moment() with no format string
  // CANNOT parse DD/MM/YYYY and returns Invalid Date, which leaked
  // straight into the document-review UI. Parse multiple known formats
  // and fall back to permissive parsing only if none match.
  const formats: moment.MomentFormatSpecification = [
    'DD/MM/YYYY',
    'YYYY-MM-DD',
    'DD-MM-YYYY',
    'DD.MM.YYYY',
    moment.ISO_8601,
  ];
  const strict = moment(date, formats, true);
  const parsed = strict.isValid() ? strict : moment(date);
  if (!parsed.isValid()) return '';
  return parsed.format(documentRenewal.previewDateFormat).toString();
};

export const getFileKey = (filePath: string): string => {
  return filePath.slice(filePath.lastIndexOf('/') + 1);
};

export const selectRecord = (seed: number, seedData: number[]): number[] => {
  const index = seedData.indexOf(seed);
  if (index !== -1) {
    seedData.splice(index, 1);
    return [...seedData];
  }
  return [seed];
};

export const formatDate = (dateString: string) => {
  return moment(dateString).format('D MMM YYYY');
};

export const expiryDue = (dateString: string) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const duration = moment().preciseDiff(moment(dateString), moment(), true);
  let expiry = '';
  if (duration.years) {
    expiry = `${duration.years} Year `;
  }
  if (duration.months) {
    expiry = expiry.concat('', `${duration.months} Month`);
  }
  return expiry;
};

export const isDatePast = (dateString: string): boolean => {
  const pastDate = new Date(dateString);
  const currentDate = new Date();
  if (pastDate < currentDate) {
    return true;
  } else {
    return false;
  }
};
